import ApplicationController from './application_controller'
import consumer from '../channels/consumer'
import CableReady from 'cable_ready'

// Givsum 3.0 vanilla-JS counterpart to auction_controller.js (which stays jQuery/isotope-based
// for the legacy catalog_show/faqs pages). Applies live AuctionChannel/UserChannel updates.
export default class extends ApplicationController {
  connect() {
    super.connect()

    const opportunityId = this.element.dataset.opportunityId
    if (!opportunityId) return

    // Apply this page load's own localStorage seed immediately, not just on next broadcast.
    refreshOutbidIndicator()
    updateMyBidsTabCount()
    highlightMyBidItems()

    consumer.subscriptions.create({ channel: 'AuctionChannel', opportunity_id: opportunityId }, {
      received: (data) => {
        if (data.cableReady) {
          CableReady.perform(data.operations)
          fixBidderIdFields()
        }
        rebuildUserBidsMap()
        refreshOutbidIndicator()
        updateMyBidsTabCount()
        // Broadcast never shows the "My Bid" ribbon server-side (current_user: nil) —
        // re-derive it from this browser's own localStorage after the card swaps in.
        highlightMyBidItems()
      },
    })

    // Keeps localStorage.userBids (and thus tab count/outbid indicator) live across pages.
    if (window.givsum_user_id) {
      consumer.subscriptions.create({ channel: 'UserChannel', user_id: window.givsum_user_id }, {
        received: (data) => {
          if (!data.cableReady) return
          CableReady.perform(data.operations)
          rebuildUserBidsMap()
          refreshOutbidIndicator()
          updateMyBidsTabCount()
          highlightMyBidItems()
        },
      })
    }
  }
}

function fixBidderIdFields() {
  if (!window.givsum_user_id) return
  document.querySelectorAll('input[name="bidder_id"]').forEach((field) => {
    if (!field.value || String(field.value) !== String(window.givsum_user_id)) {
      field.value = window.givsum_user_id
    }
  })
}

function refreshOutbidIndicator() {
  const indicator = document.getElementById('outbid_indicator')
  if (!indicator) return
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    const hasOutbids = myBids.some((bid) => bid.winning_bid === false)
    indicator.classList.toggle('d-none', !hasOutbids)
  } catch (e) {
    // malformed localStorage, ignore
  }
}

// userBids (plural) refreshes live via broadcast; userBidsMap only ever builds once at page
// load. Rebuild it here so the "already bid on this item" check never goes stale.
function rebuildUserBidsMap() {
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    const map = {}
    myBids.forEach((bid) => { map[bid.store_item_id] = bid })
    localStorage.setItem('userBidsMap', JSON.stringify(map))
  } catch (e) {
    // malformed localStorage, ignore
  }
}

function highlightMyBidItems() {
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    const myBidItemIds = new Set(myBids.map((bid) => String(bid.store_item_id)))

    // Re-derive from scratch so an item loses its ribbon after a cancel, not just gains one.
    document.querySelectorAll('[id^="items_list_store_item_"]').forEach((container) => {
      const ribbon = container.querySelector('.card-ribbon--my-bid')
      if (!ribbon) return
      const itemId = container.id.replace('items_list_store_item_', '')
      ribbon.classList.toggle('d-none', !myBidItemIds.has(itemId))
    })
  } catch (e) {
    // malformed localStorage, ignore
  }
}

function updateMyBidsTabCount() {
  const countEl = document.querySelector('#my-bids-tab .tab-count')
  if (!countEl) return
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    countEl.textContent = `(${myBids.length})`
  } catch (e) {
    // malformed localStorage, ignore
  }
}
